import { PortfolioItems, SideBarItemI } from './sidebar.interfaces';
import { UTRADE_ONE_AI_PATH, DASHBOARD_PATH, OPERATOR_DASHBOARD_PATH, CONFIGURABLE_IMAGES } from '@app/_helpers';
import { AlgoPermissions } from '../../../../utProto/webEnums_pb';
import { MIXPANEL_EVENTS } from '@app/_shared/providers/mixpanel/mixpanel.events';

export const createPortfolios: PortfolioItems[] = [
    {
        label: 'Create New Portfolio',
        route: '/trading/strategies/create',
        nested: true,
        permission: AlgoPermissions.WEBALGOPERMISSION_HIDECUSTOMPORTFOLIO
    },
    {
        label: 'Publish External Portfolio',
        route: '/trading/creator-space/external-strategy',
        nested: false,
        permission: AlgoPermissions.WEBALGOPERMISSION_EXTERNALSTRATEGY
    },
    {
        label: 'Upload Portfolio',
        route: '',
        nested: false,
        permission: AlgoPermissions.WEBALGOPERMISSION_DOWNLOADUPLOADPORTFOLIO
    },
    

]

export const createStrategies: PortfolioItems[] = [
    {
        label: 'Create New Strategy',
        route: '/trading/strategies/create-strategy',
        nested: true
    },
    {
        label: 'Publish External Strategy',
        route: '/trading/creator-space/external-strategy',
        nested: false
    }

]

export const headerItems: SideBarItemI[] = [
    {
        label: 'Home',
        icon: 'home',
        route: DASHBOARD_PATH,
        badge: false
    },
    {
        label: 'Portfolio',
        icon: 'bookmarks',
        route: '/trading/my-strategies',
        badge: false,
        event: MIXPANEL_EVENTS.NAVIGATE_PORTFOLIOS
    },
    {
        label: 'Books',
        icon: 'import_contacts',
        route: '/trading/books',
        badge: false,
        event: MIXPANEL_EVENTS.NAVIGATE_BOOKS
    },
    {
        label: 'Strategy Builder',
        icon: 'import_contacts',
        route: '/trading/strategies/create-strategy',
        badge: false,
        event: MIXPANEL_EVENTS.NAVIGATE_STRATEGY_BUILDER
    },
    {
        label: 'Watchlist',
        icon: 'import_contacts',
        route: '/trading/marketwatch',
        visible: false,
        event: MIXPANEL_EVENTS.NAVIGATE_WATCHLIST
    },
    {
        label: 'Tools',
        icon: 'show_chart',
        route: '/trading/pay-off-curve',
        badge: false,
        tool: true
    },
    {
        label: 'uTrade Intelligence',
        icon: 'show_chart',
        route: UTRADE_ONE_AI_PATH,
        visible: false,
        event: MIXPANEL_EVENTS.NAVIGATE_AI_TAB
    },
    {
        label: 'Dashboard',
        icon: 'show_chart',
        route: OPERATOR_DASHBOARD_PATH,
        visible: false
    }
];

export const toolItems: SideBarItemI[] = [
    {
        label: 'Pay-off Curve',
        icon: 'show_chart',
        route: '/trading/pay-off-curve',
        badge: false,
        img: CONFIGURABLE_IMAGES.payOffCurveIcon,
        event: MIXPANEL_EVENTS.NAVIGATE_PAY_OFF_CURVE
    },
    {
        label: 'Margin Calculator',
        icon: 'show_chart',
        route: '/trading/margin-calculator',
        badge: false,
        img: CONFIGURABLE_IMAGES.marginCalculatorIcon,
        event: MIXPANEL_EVENTS.NAVIGATE_MARGIN_CALCULATOR
    }
]

export const sidebarItems: SideBarItemI[] = [
    ...headerItems,
    ...toolItems
].filter(item => item.label !== 'Tools');